'use client';

import { CheckboxGroup, Fieldset } from '@chakra-ui/react';
import type { FormCheckboxGroupInputProps, FormType } from '../../types/types';
import { useController, useFormContext } from 'react-hook-form';

import { FormField } from '../FormField/FormField';

export const FormCheckboxGroupInput = <T extends FormType>({
	name,
	label,
	helperText,
	optionalText,
	isRequired,
	children,
	_formField,
}: FormCheckboxGroupInputProps<T>) => {
	const { control, formState } = useFormContext();
	const controller = useController({
		control,
		name,
	});

	const invalid = !!formState.errors[name];
	const { value, onChange } = controller.field;

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={isRequired}
			{..._formField}
		>
			<CheckboxGroup
				invalid={invalid}
				name={name}
				value={value}
				onValueChange={onChange}
			>
				<Fieldset.Content>
					{children}
				</Fieldset.Content>
			</CheckboxGroup>
		</FormField>
	);
};